<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>{{ 'project.reports.constraintCompliance.title' | translate }}</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
        <ng-container *ngIf="reportData$ | async as reportData">
            <div class="modal-body">
                <div class="report-content">
                    {{ 'project.reports.constraintCompliance.title' | translate }}<br />
                    {{ 'project.reports.constraintCompliance.averageHops' | translate: reportData }}<br />
                    <button
                        [disabled]="reportData.nx_max_hops === 0"
                        [routerLink]="['/', { outlets: { popup: 'project-view/constraint-compliance-node-list/max-hops' } }]"
                        class="btn btn-link _btn-sm no-padding align-baseline btn--max-hop"
                    >
                        {{ 'project.reports.constraintCompliance.nx_max_hops' | translate: reportData }}
                    </button>
                    {{ 'project.reports.constraintCompliance.exceed_max_hops' | translate }}
                    <br />

                    <button
                        [disabled]="reportData.nx_max_links === 0"
                        [routerLink]="['/', { outlets: { popup: 'project-view/constraint-compliance-node-list/max-links' } }]"
                        class="btn btn-link _btn-sm no-padding align-baseline btn--max-links"
                    >
                        {{ 'project.reports.constraintCompliance.nx_max_links' | translate: reportData }}
                    </button>
                    {{ 'project.reports.constraintCompliance.exceed_links_limit' | translate }}
                    <br />

                    <button
                        [disabled]="reportData.interferenceLinksCount === 0"
                        [routerLink]="['/', { outlets: { popup: 'project-view/nodes-with-interference' } }]"
                        class="btn btn-link _btn-sm no-padding align-baseline btn--links-interference"
                    >
                        {{ 'project.reports.constraintCompliance.interferenceLinksCount' | translate: reportData }}
                    </button>
                    {{ 'project.reports.constraintCompliance.links_with_interference' | translate }}
                </div>
            </div>
            <div class="modal-footer-button">
                <button
                    (click)="exportToExcel()"
                    [disabled]="reportData.nx_max_hops === 0 && reportData.nx_max_links === 0 && reportData.interferenceLinksCount === 0"
                    windeGreen
                >
                    {{ 'project.reports.constraintCompliance.export_to_excel' | translate }}
                </button>
            </div>
        </ng-container>
    </div>
</div>
